import React from "react";
import { Link } from "react-router-dom";
import { FiCheckCircle, FiZap, FiShield, FiStar, FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import PremiumHero from "../components/common/PremiumHero";

const Box = ({ title, icon, children }) => (
  <div className="bg-white border rounded-2xl p-6">
    <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span className="text-[#e11d7b]">{icon}</span> {title}
    </h3>
    <div className="text-gray-700 leading-relaxed">{children}</div>
  </div>
);

export default function LaserClinic() {
  return (
    <div className="bg-white">
      <PremiumHero
        title="Maxula Laser Clinic"
        subtitle="Votre centre d’épilation définitive & soins esthétiques premium"
      />

      <section className="py-14 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-white border rounded-2xl p-6 leading-relaxed text-gray-700">
            <p className="font-medium text-gray-900">
              Bienvenue dans Maxula Laser Clinic, l'espace dédié à la beauté, au bien-être et à l’esthétique avancée.
            </p>
            <p className="mt-4">
              Nous proposons une épilation laser haut de gamme pour femmes et hommes, ainsi qu’un service unique :
              <b> la mise en relation avec les meilleurs médecins</b> du Maroc et de l’étranger
              pour vos interventions esthétiques (greffe, botox, fillers, chirurgie…).
            </p>
          </div>

          <Box title="1. Épilation définitive — Femmes & Hommes" icon={<FiZap />}>
            <div className="mt-2 grid sm:grid-cols-2 gap-3">
              {[
                "Visage",
                "Jambes",
                "Bras",
                "Aisselles",
                "Maillot (toutes versions)",
                "Torse & dos",
                "Barbe / cou",
                "Corps complet"
              ].map((x) => (
                <div key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </div>
              ))}
            </div>
            <p className="mt-4 text-sm text-gray-600">
              Résultats visibles, durables, sécurisés.
            </p>
          </Box>

          <Box title="2. Appareils laser haut de gamme" icon={<FiShield />}>
            <ul className="space-y-2">
              {[
                "Séances quasi indolores",
                "Efficacité sur peaux claires & foncées",
                "Résultats rapides",
                "Haute sécurité",
                "Techniciennes formées + protocole strict"
              ].map((x) => (
                <li key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </li>
              ))}
            </ul>
          </Box>

          <Box title="3. Intermédiation médicale premium" icon={<FiStar />}>
            <p>
              Maxula vous met en relation avec des spécialistes réputés pour :
            </p>
            <div className="mt-3 grid sm:grid-cols-2 gap-3">
              {[
                "Greffe de cheveux (Maroc, Turquie, Suisse, France)",
                "Botox & Fillers",
                "Blépharoplastie",
                "Médecine esthétique (PRP, Skinbooster, mésothérapie, anti-âge)",
                "Chirurgie esthétique (rhinoplastie, liposuccion, implants, lifting, body contouring)"
              ].map((x) => (
                <div key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </Box>

          <div className="bg-white border rounded-2xl p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-3">Comment ça marche ?</h3>
            <ol className="space-y-2 text-gray-700">
              <li><b>1.</b> Choisissez votre offre</li>
              <li><b>2.</b> Vous recevez un coupon</li>
              <li><b>3.</b> Vous prenez rendez-vous</li>
              <li><b>4.</b> Séance ou intervention</li>
              <li><b>5.</b> Suivi & accompagnement Maxula</li>
            </ol>

            <div className="mt-6 flex justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#e11d7b] text-white font-semibold shadow hover:shadow-lg transition"
              >
                Prendre rendez-vous
              </Link>
            </div>
          </div>

          <div className="bg-white border rounded-2xl p-6 text-sm text-gray-700">
            <h3 className="font-bold mb-3">📞 Contact Maxula Laser Clinic</h3>
            <p className="flex items-center gap-2"><FiMapPin className="text-[#e11d7b]" /> Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger</p>
            <p className="mt-2 flex items-center gap-2"><FiPhone className="text-[#e11d7b]" /> 0539 34 24 94 — 0606 06 61 62</p>
            <p className="mt-2 flex items-center gap-2"><FiMail className="text-[#e11d7b]" /> laser@maxula.ma</p>
          </div>
        </div>
      </section>
    </div>
  );
}
